'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _darkenColor = require('../../utils/darkenColor.js');

var _darkenColor2 = _interopRequireDefault(_darkenColor);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var stdIconSide = 24;

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      width = _ref.width,
      height = _ref.height;

  var style = _styles2.default.img(width, height);
  if (icon) {
    if (typeof icon === 'string' || icon instanceof String) return _react2.default.createElement('img', { style: style, src: icon, alt: '' });else {
      var image = findUnderlyingImage(icon);
      if (image) {
        return (0, _react.createElement)(image.type, Object.assign({
          style: style
        }, image.props.viewBox ? { viewBox: image.props.viewBox } : {}), image.props.children);
      }
    }
  }
  return null;
};

var findUnderlyingInChildrenRec = function findUnderlyingInChildrenRec(_ref2) {
  var _ref3 = _toArray(_ref2),
      child = _ref3[0],
      children = _ref3.slice(1);

  if (child === undefined) return false;

  return findUnderlyingImage(child) || findUnderlyingInChildrenRec(children);
};

// Searching for something to display in passed element
var findUnderlyingImage = function findUnderlyingImage() {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (icon.type === 'svg' || icon.type === 'img') {
    // If a display element is found
    return icon;
  } else if (typeof icon.type === 'string') {
    // if underlying is a dom-element
    return findUnderlyingInChildrenRec(_react2.default.Children.toArray(icon.props.children));
  } else if (!icon.type.prototype.render && typeof icon.type === 'function') {
    // if it is stateless
    return findUnderlyingImage(icon.type(icon.props)); // Calling types instantiates it so we can look for more
  } else if (typeof icon.type !== 'string' && icon.type.prototype.render) {
    console.error('@Billes/components: Cannot read underlying implementation of ' + icon.type.name + ' because it is an instance of "React.Component". Please use stateless components instead.');
  }

  return false;
};

var getText = function getText(label, name) {
  if (label) return label;else if (name) {
    console.warn('@Billes/components: Property "name" is deprecated. Please use "label" instead.');
    return name;
  }

  return '';
};

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item(props) {
    _classCallCheck(this, Item);

    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

    _this.state = {
      hover: false
    };

    _this.hovered = _this.setHover.bind(_this);
    _this.unhovered = _this.setHover.bind(_this, false);
    return _this;
  }

  _createClass(Item, [{
    key: 'setHover',
    value: function setHover(isHovered) {
      this.setState(function () {
        return { hover: isHovered };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          action = _props.action,
          _props$icon = _props.icon,
          icon = _props$icon === undefined ? null : _props$icon,
          _props$link = _props.link,
          link = _props$link === undefined ? null : _props$link,
          name = _props.name,
          label = _props.label,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          _props$width = _props.width,
          width = _props$width === undefined ? 'auto' : _props$width,
          _props$flip = _props.flip,
          flip = _props$flip === undefined ? false : _props$flip,
          _props$target = _props.target,
          target = _props$target === undefined ? '_self' : _props$target,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style;


      var rawButtonStyle = Object.assign({}, _styles2.default.item(width), style);

      var buttonStyle = Object.assign({}, rawButtonStyle, this.state.hover && !disabled ? { background: (0, _darkenColor2.default)(rawButtonStyle.background, -25) } : {}, disabled ? Object.assign({}, _styles2.default.disabled, { color: (0, _darkenColor2.default)(rawButtonStyle.color, 90) }) : {});

      var iconComponent = icon ? icon.component || icon : null;
      var iconWidth = icon && icon.width ? icon.width : stdIconSide;
      var iconHeight = style.height < 24 ? style.height : stdIconSide;

      var content = [_react2.default.createElement(Icon, {
        key: 'icon',
        icon: iconComponent,
        width: iconWidth,
        height: iconHeight
      }), _react2.default.createElement(
        'span',
        { key: 'text', style: _styles2.default.span(iconWidth, icon, flip) },
        getText(label, name)
      )];

      var item = _react2.default.createElement(
        'button',
        {
          ref: function ref(el) {
            return _this2.element = el;
          },
          href: link,
          target: target,
          onClick: action && !disabled ? function (e) {
            e.preventDefault();
            action();
          } : null,
          style: buttonStyle,
          onMouseEnter: this.hovered,
          onMouseLeave: this.unhovered },
        _react2.default.createElement('span', { style: _styles2.default.verticalAlignmentHelper }),
        flip ? content.reverse() : content
      );

      if (link) return _react2.default.createElement('a', item.props);

      return item;
    }
  }]);

  return Item;
}(_react.Component);

exports.default = Item;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/components/lib/components/Action/index.js
// module id = 202
// module chunks = 5